import React from "react";
import { SCENARIO } from "../scenario/torbridge.js";

export function Footer() {
  return (
    <footer className="footer">
      <p>
        {SCENARIO.disclosure} Built on <span className="footer-link">{SCENARIO.product.name}</span>:{" "}
        {SCENARIO.product.tagline}.
      </p>
    </footer>
  );
}
